import React, { useEffect, useState } from 'react'
import { Formik } from 'formik'
import { FaUserAlt } from 'react-icons/fa'
import { CircularProgress } from '@material-ui/core'
import { TextFieldIcon, Button, Panel, SelectFieldIcon } from './_components'
import UGLogo from './_images/uganda.png'
import { Dashboard, Registered, AddFarmer, AllSMS, 
  AllLeaders, SendSMS, FarmerPayment,PaymentForm, 
  WaterPaymentList, SharesList, MembershipList,
  EditProductionForm, ViewProductionForm,
  AllUsers, DisplayRecord, Production, AddLeader } from './_screens'
import Axios from 'axios'
import Users from './_screens/Users'
import Theme from './Theme'
import Form from './_screens/Production/Form'
import data from './fixtures'

function App() {
  const [ type, setType ] = useState( null )
  const [ loading, setLoading ] = useState( true )
  const [ signing, setSigning ] = useState( false )
  const [ users, setUsers ] = useState( [] )

  useEffect( () => {
    if( type ){
      localStorage.removeItem( "name" )
      localStorage.setItem( "name", type )
      window.location.reload()
    }
  }, [ type ] )

  useEffect( () => {
    if( loading ) {
      fetchUsers()
    }
  }, [ loading ])

  const fetchUsers = async () => {
    try {
      const response = await Axios.get( `https://mis.nec.go.ug/api/auth/fiefoc_user` )
      if( response.data ) {
        setUsers( response.data.records )
      }
    } catch (error) {}
  }

  const handleLogin = async ( values ) => {
    try {
      if( values.module ){
           await localStorage.setItem( "scheme", values.scheme )
           await localStorage.setItem( "module", values.module )
           await localStorage.setItem( "name", "dashboard" )
           return window.location.reload()
      }
    } catch (error) {}
  }

  const handleSubmit = async ( values ) => {
    try {
      const user = users.filter( user => user.username?.toLowerCase() === values.email?.trim()?.toLowerCase() && user.password?.toLowerCase() === values.password?.trim()?.toLowerCase() )
      if( user.length > 0 ) {
        await localStorage.setItem( "fullname", user[ 0 ].name )
        await localStorage.setItem( "role", user[ 0 ].role )
        await localStorage.setItem( "username", user[ 0 ].username )
        await localStorage.setItem( "user_scheme", user[ 0 ].scheme )
        await localStorage.setItem( "email", user[ 0 ].email_address )
        
        //navigate to filter
        localStorage.setItem( "name", "filter" )
        window.location.reload()
      }
      else {
        alert( "User not found. Wrong credentials given." )
      }
    } catch (error) {
      alert( "Server error occured. Could not Login." )
    }
  }

  if( localStorage.getItem( "name" ) === "display_farmer" ) {
    return <DisplayRecord />
  }

  if( localStorage.getItem( "name" ) === "add_user" ) {
    return <Users />
  }

  if( localStorage.getItem( "name" ) === "view_users" ) {
    return <AllUsers />
  }

  if( localStorage.getItem( "name" ) === "view_sms" ) {
    return <AllSMS />
  }

  if( localStorage.getItem( "name" ) === "view_leaders" ) {
    return <AllLeaders />
  }

  if( localStorage.getItem( "name" ) === "send_sms" ) {
    return <SendSMS />  
  } 

  if( localStorage.getItem( "name" ) === "dashboard" ) {
    return <Dashboard />
  }

  if( localStorage.getItem( "name" ) === "view_farmers" ) {
    return <Registered />
  }

  if( localStorage.getItem( "name" ) === "payments" ) {
    return <FarmerPayment />
  }

  if( localStorage.getItem( "name" ) === "add_payment" ) {
    return <PaymentForm />
  }

  if( localStorage.getItem( "name" ) === "water_payments" ) {
    return <WaterPaymentList />
  }

  if( localStorage.getItem( "name" ) === "share_payments" ) {
    return <SharesList />
  }

  if( localStorage.getItem( "name" ) === "membership_payments" ) {
    return (
      <MembershipList />
    )
  }

  if( localStorage.getItem( "name" ) === "register_farmer" ) {
    return <AddFarmer />
  }

  if( localStorage.getItem( "name" ) === "filter" ){
    return (
      <div className="w-screen h-screen overflow-x:hidden overflow-y-hidden md:overflow-y-hidden lg:overflow-y-hidden bg-gray-100">
        <div className="w-full h-full flex items-center justify-center my-5">
          <div className= "p-12 lg:w-2/5 md:w-2/5 w-full h-auto bg-white rounded-sm shadow-xl ">
            <div className="flex flex-col items-center justify-center">
              <h2 className="font-bold md:text-base lg:text-base text-sm px-1 py-1">
                {`Welcome to Small & Medium Scale Irrigation Schemes`}
              </h2>
              <h6 className="font-bold md:text-base lg:text-base text-sm p-2">
                {`Management Information System`}
              </h6>
            </div>
            <Panel label="Which module would you like to use?">
              <Formik initialValues={{
                  scheme: "",
                  module: "",
              }} onSubmit={handleLogin}>
                  { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                      return (
                          <form onSubmit={handleSubmit}>
                            <div className="w-full py-2 grid grid-cols-1">
                              <SelectFieldIcon
                                name="scheme"
                                value={values.scheme}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                iconComponent={<FaUserAlt color={`#666`} />}
                                label="Scheme"  
                                options={data.moduleSchemes.filter( item => {
                                  if( localStorage.getItem( "user_scheme" ) !== "ALL"  ) {
                                    return localStorage.getItem( "user_scheme" )?.toLowerCase() === item.label?.toLowerCase()
                                  }
                                  return item

                                } )}
                                required={true}
                                question="What is the name of your scheme?" />
                            </div>
      
                            <div className="w-full py-2 grid grid-cols-1">
                              <SelectFieldIcon
                                name="module"
                                value={values.module}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                iconComponent={<FaUserAlt color={`#666`} />}
                                label="Choose Module"  
                                options={[
                                    { id: 1, value: "Registration", label: "Farmer Registration module" },
                                    { id: 2, value: "Production", label: "Farmer Production data module" },
                                    { id: 3, value: "Knowledge", label: "Farmer Knowledge transfer module" },
                                    { id: 4, value: "Aggregation", label: "Farmer data aggregation module" },
                                    { id: 5, value: "Payment", label: "Payment and other financial services module" }
                                ]}
                                required={true}
                                question="What is the name of your module?" />
                            </div>
      
                            <div className="w-full py-2 grid grid-cols-1">
                                {signing ? (
                                <div className="flex items-center justify-center">
                                  <CircularProgress size={24} color="primary" />
                                </div>
                                ):
                                  ( <Button 
                                    loading={isSubmitting} 
                                    disabled={isSubmitting ? true : false} 
                                    label={"Submit"} /> )
                                }
                            </div>
                          </form>
                      )
                  }  }
              </Formik>
            </Panel>
          </div>
         </div>
        <div> 
        </div>
      </div>
    )
  }

  if( localStorage.getItem( "name" ) === "login" ){
    return (
      <div className="w-screen h-screen overflow-x:hidden overflow-y-hidden md:overflow-y-hidden lg:overflow-y-hidden bg-gray-50">
        <div className="w-full h-full flex items-center justify-center md:my-5 lg:my-5">
          <div className= "md:p-12 lg:p-12 p-5 lg:w-2/5 md:w-2/5 w-full h-auto bg-white rounded shadow-md mx-2">
            <div className="flex flex-col items-center justify-center">
              <div className="flex w-full items-center justify-evenly">
               <img src={UGLogo} alt="Coat of Arms" className="md:w-14 lg:w-14" />
              </div>
              <h2 className="font-bold px-3 py-2 text-center md:text-xl lg:text-xl text-base">
                {`Small and Medium Scale Irrigation Schemes`}
              </h2>
              <h6 className="font-bold p-2 text-center md:text-lg lg:text-lg text-sm">
                {`Management Information System`}
              </h6>
            </div>
            <Formik initialValues={{
                email: "",
                password: "",
            }} onSubmit={handleSubmit}>
                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                  return (
                      <form onSubmit={handleSubmit}>
                        <div className="w-full py-2 grid grid-cols-1">
                          <TextFieldIcon 
                            name="email"
                            type="text"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.email}
                            iconComponent={Theme.EmailIcon} 
                            label="Username"
                            required={true}
                            disabled={signing}
                            question="Your Username" />
                        </div>
  
                        <div className="w-full py-2 grid grid-cols-1">
                          <TextFieldIcon 
                            name="password"
                            type="password"
                            label="Password"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.password}
                            iconComponent={Theme.LockIcon}
                            required={true}
                            disabled={signing}
                            question="Your Password"
                          />
                        </div>
  
                        <div className="w-full py-2 grid grid-cols-1">
                            {signing ? (
                            <div className="flex items-center justify-center">
                              <CircularProgress size={24} color="primary" />
                            </div>
                            ):
                              ( <Button 
                                type="submit"
                                loading={isSubmitting} 
                                disabled={isSubmitting ? true : false} 
                                label={"Sign In"} /> )
                            }
                        </div>
                      </form>
                  )
                }  }
            </Formik>
          </div>
         </div>
        <div> 
       </div>
      </div>
    )
  }

  if( localStorage.getItem( "name" ) === "production" ) {
    return <Production />
  }

  if( localStorage.getItem( "name" ) === "ProductionForm" ) {
    return <Form />
  }

  if( localStorage.getItem( "name" ) === "ViewProductionForm" ) {
    return <ViewProductionForm />
  }

  // if( localStorage.getItem( "name" ) === "view_production_all" ) {
  //   return <AllProduction />
  // }
  if( localStorage.getItem( "name" ) === "EditProductionForm" ) {
    return <EditProductionForm />
  }
  if( localStorage.getItem( "name" ) === "add_leader" ) {
    return <AddLeader />
  }
  
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <button 
        type="button"
        className="bg-red-500 px-5 py-2 text-lg text-white" 
        onClick={() => setType( "login" )}>
        {`Login`}
      </button>
    </div>
  )
}
export default App;
